import type { JSX } from 'react'
import { Grid, Skeleton, Typography } from '@mui/material'

/**
 *
 * @header Left-hand side label
 * @content Right-hand side content (string) or element
 * @loadingWidth Loading width of the skeleton
 */
const Subsection = ({
  header,
  loading,
  content,
  loadingWidth = 150,
  hideSkeleton = false,
}: {
  header: string
  loading: boolean
  content?: string | JSX.Element
  loadingWidth?: number
  hideSkeleton?: boolean
}) => (
  <Grid
    container={true}
    sx={{
      marginBottom: 2,
    }}
  >
    <Grid
      container={true}
      sx={{
        width: '177px',
      }}
    >
      <Typography variant="body1" color="GrayText">
        {header}
      </Typography>
    </Grid>
    <Grid
      container={true}
      size="grow"
      sx={{
        gap: '28px',
        minWidth: '275px',
      }}
    >
      {loading && !hideSkeleton && <Skeleton variant="text" width={loadingWidth} />}
      {((content && !loading) || (content && hideSkeleton)) && content}
    </Grid>
  </Grid>
)

export default Subsection
